// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c81kw7{font:inherit}\n._1hmsglyw{text-decoration-line:none}\n._4bfu1r31{text-decoration-color:currentColor}\n._ajmmnqa1{text-decoration-style:solid}\n._syaz1fxt{color:var(--ds-text,#172b4d)}\n._1bnx8stv:hover{text-decoration-line:underline}\n._30l314q2:hover{color:var(--ds-link,#0c66e4)}\n._9oik1r31:hover{text-decoration-color:currentColor}\n._jf4cnqa1:hover{text-decoration-style:solid}\n._9h8h16c2:active{color:var(--ds-link-pressed,#05c)}", ""]);
// Exports
module.exports = exports;
